export default __webpack_public_path__ + "static/media/8848_Logo_pos.5e7a9efc.svg";